import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type SearchDTO } from '@api/models';
import { environment } from '@environments/environment';
import { type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private readonly http = inject(HttpClient);

  searchAll(searchText: string, onlyActiveCustomers: boolean, countryCode: string): Observable<SearchDTO> {
    let uri = `${environment.api}/search`;

    const parameters = new URLSearchParams();

    if (searchText) {
      parameters.append('term', searchText);
    }

    if (onlyActiveCustomers) {
      parameters.append('onlyActiveCustomers', onlyActiveCustomers.toString());
    }

    if (countryCode) {
      parameters.append('countryCode', countryCode);
    }

    if (parameters.toString()) {
      uri += `?${parameters.toString()}`;
    }

    return this.http.get<SearchDTO>(uri);
  }
}
